import type { ComponentRegistry } from '../../component-registry';

/**
 * Get supported blocks for ContentArea rendering
 *
 * This is exported as a function rather than a plain object because:
 *   - This file is imported by ContentAreaItem
 *   - Some components indirectly import ContentAreaItem, creating a circular dependency
 *   - Webpack solves the problem of circular dependencies by setting the circular imports to 'undefined', meaning rendering will fail
 *   - Exporting as a function rather than a plain object magically solves this by deferring the import until runtime
 *
 * @returns The component registry object
 */
export default function (): ComponentRegistry {
  // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-unsafe-assignment
  const { Components } = require('../../component-registry');
  return Components as ComponentRegistry;
}
